export default __webpack_public_path__ + "static/media/admin-main-lg.207d09cd.jpg";